import { render, staticRenderFns } from "./MISDashboardComponent.vue?vue&type=template&id=44b0579c"
import script from "./MISDashboardComponent.vue?vue&type=script&lang=js"
export * from "./MISDashboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports